import Vue from 'vue'
import firebase from "firebase";

const state = {
  user: false,
  appointments: [],
  locations: [],
  posts: [],
  projects: [],
  survey: false,
  projectSlots: []
};

const actions = {
  bindAnything({ commit, state }, {id, collection, then, reference} ) {
    if( !id ){
      return;
    }
    let exists = state[reference].find( a => a.id == id );
    if( !exists ){    
      firebase.firestore().collection(collection).doc(id).onSnapshot(snapshot => {
          commit(then, { id: snapshot.id, data: snapshot.data(), reference: reference });
      });
      return true;
    }
    return false;
  },

  fetchPost({dispatch}, id ){
    dispatch("bindAnything", {id: id, collection: "posts", then: "SET_ANYTHING", reference: "posts" } )
  },
  fetchUser({commit}){
    firebase.firestore().doc( "users/" + firebase.auth().currentUser.uid ).onSnapshot( (doc) => {
      let user = doc.data();
      user.id = doc.id; 
      commit("SET_ONETHING", {ref: "user", data: user })
    })
  },
  fetchAppointments({dispatch}){
    var date = new Date();
    date.setDate( date.getDate() - 1 );
    firebase.firestore().collection("appointments").where("participant", "==", firebase.auth().currentUser.uid ).where('dateTime', '>=', date  )
    .onSnapshot( (snapshot) => {
      snapshot.forEach( doc => {  
        if(doc.data().publishStatus ==  "live"){
          dispatch("bindAnything", {id: doc.id, collection: "appointments", then: "SET_ANYTHING", reference: "appointments"} )
        }
      })
    })
  },
  fetchSlots({commit}, id){
    firebase.firestore().doc( "projectSlots/" + id ).onSnapshot( (doc) => {
      let slots = doc.data();
      commit("SET_ANYTHING", {ref: "projectSlots", data: slots, id: doc.id })
    })
  },
  fetchProject({commit, dispatch}, id){
    firebase.firestore().doc( "projects/" + id ).onSnapshot( (doc) => {
      let project = {
        id: doc.data().id,
        includeVideoCalling: doc.data().includeVideoCalling,
        instruction: doc.data().instruction,
        location: doc.data().location,
        participantName: doc.data().participantName,
        methodology: doc.data().methodology,
        screener: doc.data().screener,
        rescreeningQuestions: doc.data().rescreeningQuestions,
      };
      if( project.location ){
        dispatch("bindAnything", {id: project.location, collection: "locations", then: "SET_ANYTHING", reference: "locations"} )
      }
      commit("SET_ANYTHING", {reference: "projects", data: project, id: doc.id })
    })
    firebase.firestore().doc( "projectSlots/" + id ).onSnapshot( (doc) => {
      let slots = doc.data();
      commit("SET_ANYTHING", {reference: "projectSlots", data: slots, id: doc.id })
    })
  },
  fetchSurvey({commit}, id){
    return new Promise((resolve) => {
      firebase.firestore().doc( "surveys/" + id ).onSnapshot( (doc) => {
        let survey = {
          id: doc.id,
          active: doc.data().active,
          elements: doc.data().elements,
          introText: doc.data().introText,
          name: doc.data().name,
          publishStatus: doc.data().publishStatus,
          headlineText: doc.data().headlineText,
          subheadingText: doc.data().subheadingText,
          blurb: doc.data().blurb,
          image: doc.data().image,
          actionBox: doc.data().actionBox,
          sendToAfter: doc.data().sendToAfter,
          showQuestionNumbers: doc.data().showQuestionNumbers,
          surveyProperties: doc.data().surveyProperties,
          allowRetrieveResponses: doc.data().allowRetrieveResponses,
        }
        if( survey.allowRetrieveResponses && firebase.auth().currentUser ){
          firebase.firestore().collection( "surveyResponses" )
          .where("respondent", "==", firebase.auth().currentUser.uid)
            .where("survey", "==", survey.id)
            .get( )
            .then( snapshot => {
              if( !snapshot.empty ){
                snapshot.forEach(doc => {
                  var response = doc.data();
                  response.id = doc.id;
                  survey.response = response;
                })
              }
              commit("SET_ONETHING", {ref: "survey", data: survey } );
              resolve(true)
            })
        }
        else{
          commit("SET_ONETHING", {ref: "survey", data: survey } )
          resolve(true)
        }
      })
    })
  }
};

const mutations = {
  SET_ONETHING(state, {ref, data}){
    Vue.set( state, ref, data );
  },
  SET_ANYTHING(state, {id, data, reference}) {
    if( !id ){ return; }
    if( typeof data == 'undefined') { return; }
    if( !state[reference] ) { return; }
    let index = state[reference].length;
    data.id = id;
    let exists = state[reference].find( p => p.id == id );
    if( exists ){
      index = state[reference].indexOf( exists )
    }
    Vue.set( state[reference], index, data );
  }

};

export default {
  state,
  actions,
  mutations,
};
